/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { accountManagement } from '@/api/ajax';

export default [
  {
    width: 180,
    label: '子账号名',
    tip: '请输入关键字',
    key: 'subAccountName',
    id: 'userName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '姓名',
    tip: '请输入关键字',
    key: 'fullName',
    id: 'fullName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '联系方式',
    tip: '请输入联系方式',
    key: 'phone',
    id: 'phone',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '部门',
    tip: '请输入部门',
    key: 'department',
    id: 'department',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '职位',
    tip: '请输入职位',
    key: 'position',
    id: 'position',
    slot: 'input',
    clearable: true
  },
  {
    id: 'createDt',
    width: 180,
    tip: '创建时间',
    label: '创建时间',
    slot: 'daterange',
    type: 'daterange',
    key: ['createDtStart', 'createDtEnd'],
    text: ['创建时间始', '创建时间止']
  },
  {
    id: 'happendTime',
    width: 180,
    tip: '发生时间',
    label: '发生时间',
    slot: 'daterange',
    type: 'daterange',
    key: ['startTime', 'endTime'],
    text: ['发生时间始', '发生时间止']
  },
  {
    id: 'roleId',
    key: 'roleId',
    tip: '角色',
    label: '角色',
    required: false,
    clearable: true,
    slot: 'ajaxSelect',
    ajax: accountManagement.subaccountManagementRoleList,
    prop: {
      label: 'roleName',
      code: 'roleId'
    },
    ajaxQuery: 'projectName',
    width: 'auto'
  },
  {
    width: 180,
    tip: '操作',
    key: 'optionType',
    id: 'optionType',
    slot: 'ajaxSelect',
    clearable: true,
    ajax: accountManagement.listLogType,
    prop: {
      label: 'name',
      code: 'key'
    },
    ajaxQuery: 'name'
  }
];
